module.exports = __webpack_public_path__ + "img/folder.0748cf2e.svg";